"use client";

import { useEffect, useState } from "react";
import { formatDateTime } from "../../utils/formatDateTime";

const PLACEHOLDER = "00/00/0000 - 00:00";

type Props = {
  /** ISO string ou `Date`. `null`/`undefined`/string vazia renderizam `null`. */
  value: string | Date | null | undefined;
};

/**
 * Renderiza data como `dd/MM/yyyy - HH:mm` no fuso do browser, evitando
 * hydration mismatch via placeholder + flip pós-mount. O atributo
 * `dateTime` carrega a ISO original desde o SSR (SEO/a11y).
 */
export function DynamicDateTime({ value }: Props) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!value) return null;

  const isoAttr = value instanceof Date ? value.toISOString() : String(value);

  return (
    <time
      dateTime={isoAttr}
      style={{ visibility: mounted ? "visible" : "hidden" }}
    >
      {mounted ? formatDateTime(value) : PLACEHOLDER}
    </time>
  );
}
